// src/components/exercises/exerciseScoring.js
import { calculateAngle } from './exerciseDetection';

const clamp01 = (v) => Math.max(0, Math.min(1, v));

const SQUAT_STAND_ANGLE = 160;   // matches detectSquats' bothStraight threshold
const SQUAT_DEPTH_RANGE = 70;    // matches detectSquats' required range for a counted rep

export const calculateSquatScore = (landmarks, standingKneeAngleRef) => {
  const leftHip = landmarks[23], leftKnee = landmarks[25], leftAnkle = landmarks[27];
  const rightHip = landmarks[24], rightKnee = landmarks[26], rightAnkle = landmarks[28];

  const visOK = [leftHip, leftKnee, leftAnkle, rightHip, rightKnee, rightAnkle]
    .every(p => p && p.visibility > 0.5);
  if (!visOK) return { score: 0, visOK: false };

  const leftKneeAngle = calculateAngle(leftHip, leftKnee, leftAnkle);
  const rightKneeAngle = calculateAngle(rightHip, rightKnee, rightAnkle);
  const kneeAngle = Math.min(leftKneeAngle, rightKneeAngle); // matches detection's use of min()

  const baseline = (standingKneeAngleRef && standingKneeAngleRef.current) || SQUAT_STAND_ANGLE;

  let score;
  if (kneeAngle >= baseline) {
    score = 0.5;
  } else {
    const drop = baseline - kneeAngle;
    score = 0.5 + 0.5 * (drop / SQUAT_DEPTH_RANGE); // 70° drop = full, matching detectSquats exactly
  }
  return { score: clamp01(score), visOK: true };
};

const ARM_THRESHOLD = 0.05;   // matches detectJumpingJacks' currentArmsUp check, unnormalized
const LEG_RATIO_STAND = 1.0;  // legs together baseline
const LEG_RATIO_FULL = 1.5;   // matches detectJumpingJacks' currentLegsApart threshold

export const calculateJJScore = (landmarks) => {
  const leftShoulder = landmarks[11], rightShoulder = landmarks[12];
  const leftWrist = landmarks[15], rightWrist = landmarks[16];
  const leftAnkle = landmarks[27], rightAnkle = landmarks[28];

  const visOK = [leftShoulder, rightShoulder, leftWrist, rightWrist, leftAnkle, rightAnkle]
    .every(p => p && p.visibility > 0.5);
  if (!visOK) return { score: 0, visOK: false };

  const leftRaise = leftShoulder.y - leftWrist.y;
  const rightRaise = rightShoulder.y - rightWrist.y;
  const avgRaise = (leftRaise + rightRaise) / 2;
  const armProgress = clamp01(avgRaise / ARM_THRESHOLD);

  const ankleDistance = Math.abs(leftAnkle.x - rightAnkle.x);
  const shoulderDistance = Math.abs(leftShoulder.x - rightShoulder.x) || 0.001;
  const legRatio = ankleDistance / shoulderDistance;
  const legProgress = clamp01((legRatio - LEG_RATIO_STAND) / (LEG_RATIO_FULL - LEG_RATIO_STAND));

  const score = 0.5 + 0.5 * Math.min(armProgress, legProgress);
  return { score: clamp01(score), visOK: true };
};